export const environment = {
    production: true,
    enableLogs: false, // Deshabilitar logs en producción
    pathBackend: 'https://backend.mirailab.io',
};
